import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { AdminOptionsNav } from '../admin-options-nav';
import {
  BrandingSectionId,
  BRANDING_SECTION_REGISTRY,
  getActiveBrandingSection,
  getBrandingSectionPath,
  isBrandingSectionRouteActive,
} from './molecules/branding-section-registry/branding-section.registry';

@Component({
  selector: 'admin-branding',
  imports: [AdminOptionsNav, RouterLink, RouterOutlet],
  templateUrl: './admin-branding.html',
  styleUrl: './admin-branding.scss',
  host: { class: 'block h-full w-full min-w-0' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBranding {
  private readonly router = inject(Router);

  readonly sections = BRANDING_SECTION_REGISTRY;

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects.split('?')[0] ?? ''),
      startWith(this.router.url.split('?')[0] ?? ''),
    ),
    { initialValue: this.router.url.split('?')[0] ?? '' },
  );

  readonly activeSection = computed(() => getActiveBrandingSection(this.currentUrl()));

  getSectionLink(sectionId: BrandingSectionId): string {
    return getBrandingSectionPath(sectionId);
  }

  isSectionSelected(sectionId: BrandingSectionId): boolean {
    return isBrandingSectionRouteActive(sectionId, this.currentUrl());
  }

  getSectionNavClass(sectionId: BrandingSectionId): string {
    return this.isSectionSelected(sectionId)
      ? 'border-primary/50 bg-primary/10 ring-1 ring-primary/35 dark:border-primary/45 dark:bg-primary/15 dark:ring-primary/25'
      : 'border-transparent hover:border-zinc-300 hover:bg-zinc-50 dark:hover:border-zinc-700 dark:hover:bg-zinc-900/50';
  }
}
